import React, { memo } from 'react';
import SortButton from '../../../components/molecules/SortButton';

export const COMPARADOR_FUNDOS_SORT_OPTIONS = [
  { label: 'Relevância', value: '' },
  { label: 'Maior taxa de administração', value: 'taxa_adm DESC' },
  { label: 'Menor taxa de administração', value: 'taxa_adm ASC' },
  { label: 'Maior aplicação mínima', value: 'aplicacao_min DESC' },
  { label: 'Menor aplicação mínima', value: 'aplicacao_min ASC' },
  { label: 'Maior carência para resgate', value: 'resgate_carencia DESC' },
  { label: 'Menor carência para resgate', value: 'resgate_carencia ASC' },
  { label: 'Maior retorno', value: 'retorno DESC' },
  { label: 'Menor retorno', value: 'retorno ASC' },
  { label: 'Maior percentual de dias acima do benchmark', value: 'perc_dias_acima_benchmark DESC' },
  { label: 'Menor percentual de dias acima do benchmark', value: 'perc_dias_acima_benchmark ASC' },
  {
    label: 'Maior percentual de meses acima do benchmark',
    value: 'perc_meses_acima_benchmark DESC'
  },
  {
    label: 'Menor percentual de meses acima do benchmark',
    value: 'perc_meses_acima_benchmark ASC'
  },
  { label: 'Maior Sharpe', value: 'sharpe DESC' },
  { label: 'Menor Sharpe', value: 'sharpe ASC' },
  { label: 'Maior tracking error', value: 'tracking_error DESC' },
  { label: 'Menor tracking error', value: 'tracking_error ASC' },
  { label: 'Maior volatilidade', value: 'volatilidade DESC' },
  { label: 'Menor volatilidade', value: 'volatilidade ASC' },
  { label: 'Maior PL', value: 'pl DESC' },
  { label: 'Menor PL', value: 'pl ASC' },
  { label: 'Maior número de cotistas', value: 'cotistas DESC' },
  { label: 'Menor número de cotistas', value: 'cotistas ASC' },
  { label: 'Maior PL do gestor', value: 'gestor_pl DESC' },
  { label: 'Menor PL do gestor', value: 'gestor_pl ASC' },
  { label: 'Maior PL do administrador', value: 'adm_pl DESC' },
  { label: 'Menor PL do administrador', value: 'adm_pl ASC' }
];

export const ATIVOS_FUND_SORT_GROUPS = [
  {
    id: 'geral',
    label: 'Geral',
    options: [{ label: 'Relevância', value: '' }]
  },
  {
    id: 'custos-condicoes',
    label: 'Custos e condições',
    options: [
      { label: 'Maior taxa de administração', value: 'taxa_adm DESC' },
      { label: 'Menor taxa de administração', value: 'taxa_adm ASC' },
      { label: 'Maior aplicação mínima', value: 'aplicacao_min DESC' },
      { label: 'Menor aplicação mínima', value: 'aplicacao_min ASC' },
      { label: 'Maior prazo para resgate', value: 'resgate_carencia DESC' },
      { label: 'Menor prazo para resgate', value: 'resgate_carencia ASC' }
    ]
  },
  {
    id: 'desempenho-risco',
    label: 'Desempenho e risco',
    options: [
      { label: 'Maior retorno', value: 'retorno DESC' },
      { label: 'Menor retorno', value: 'retorno ASC' },
      {
        label: 'Maior percentual de dias acima do benchmark',
        value: 'perc_dias_acima_benchmark DESC'
      },
      {
        label: 'Menor percentual de dias acima do benchmark',
        value: 'perc_dias_acima_benchmark ASC'
      },
      {
        label: 'Maior percentual de meses acima do benchmark',
        value: 'perc_meses_acima_benchmark DESC'
      },
      {
        label: 'Menor percentual de meses acima do benchmark',
        value: 'perc_meses_acima_benchmark ASC'
      },
      { label: 'Maior Sharpe', value: 'sharpe DESC' },
      { label: 'Menor Sharpe', value: 'sharpe ASC' },
      { label: 'Maior tracking error', value: 'tracking_error DESC' },
      { label: 'Menor tracking error', value: 'tracking_error ASC' },
      { label: 'Maior volatilidade', value: 'volatilidade DESC' },
      { label: 'Menor volatilidade', value: 'volatilidade ASC' }
    ]
  },
  {
    id: 'patrimonio-cotistas',
    label: 'Patrimônio e cotistas',
    groups: [
      {
        id: 'fundo',
        label: 'Fundo',
        options: [
          {
            label: 'Maior patrimônio líquido',
            selectedLabel: 'Fundo — maior patrimônio líquido',
            value: 'pl DESC'
          },
          {
            label: 'Menor patrimônio líquido',
            selectedLabel: 'Fundo — menor patrimônio líquido',
            value: 'pl ASC'
          },
          {
            label: 'Maior número de cotistas',
            selectedLabel: 'Fundo — maior número de cotistas',
            value: 'cotistas DESC'
          },
          {
            label: 'Menor número de cotistas',
            selectedLabel: 'Fundo — menor número de cotistas',
            value: 'cotistas ASC'
          }
        ]
      },
      {
        id: 'gestor',
        label: 'Gestor',
        options: [
          {
            label: 'Maior patrimônio líquido',
            selectedLabel: 'Gestor — maior patrimônio líquido',
            value: 'gestor_pl DESC'
          },
          {
            label: 'Menor patrimônio líquido',
            selectedLabel: 'Gestor — menor patrimônio líquido',
            value: 'gestor_pl ASC'
          },
          {
            label: 'Maior número de cotistas',
            selectedLabel: 'Gestor — maior número de cotistas',
            value: 'gestor_cotistas DESC'
          },
          {
            label: 'Menor número de cotistas',
            selectedLabel: 'Gestor — menor número de cotistas',
            value: 'gestor_cotistas ASC'
          }
        ]
      },
      {
        id: 'administrador',
        label: 'Administrador',
        options: [
          {
            label: 'Maior patrimônio líquido',
            selectedLabel: 'Administrador — maior patrimônio líquido',
            value: 'adm_pl DESC'
          },
          {
            label: 'Menor patrimônio líquido',
            selectedLabel: 'Administrador — menor patrimônio líquido',
            value: 'adm_pl ASC'
          },
          {
            label: 'Maior número de cotistas',
            selectedLabel: 'Administrador — maior número de cotistas',
            value: 'adm_cotistas DESC'
          },
          {
            label: 'Menor número de cotistas',
            selectedLabel: 'Administrador — menor número de cotistas',
            value: 'adm_cotistas ASC'
          }
        ]
      }
    ]
  }
];

/** Exibe o controle de ordenação dos fundos encontrados. */
const ComparadorFundosSortButton = memo(({ sort, onChange }) => (
  <SortButton
    id="comparador-fundos-sort"
    ariaLabel="Ordenar ativos"
    value={sort || ''}
    options={COMPARADOR_FUNDOS_SORT_OPTIONS}
    groups={ATIVOS_FUND_SORT_GROUPS}
    onChange={onChange}
  />
));

export default ComparadorFundosSortButton;
